import { Component, inject, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '../../../common/components/base.component';
import { AchBillingComponent } from '../ach-billing/ach-billing.component';
import { CreditCardBillingComponent } from '../credit-card-billing/credit-card-billing.component';
import { LanguageStateService } from '../../../common/services/language-state.service';
import { OrderFlowType } from '../order-flow-type';
export enum OOFProvidersEnum {
    EARTHLINK = 'earthlink',
    CONSOLIDATED = 'consolidated',
    BRIGHTSPEED = 'brightspeed',
    ALTAFIBER = 'altafiber',
    HAWAIIAN_TELECOM = 'hawaiiantelcom',
    ZIPLY = 'ziply',
    FRONTIER = 'frontier',
    CHARTER = 'charter',
    SPECTRUM = 'spectrum',
    VIASAT = 'viasat internet',
    WINDSTREAM = 'windstream',
    OPTIMUM = 'optimum',
    WOW = 'wow',
    HUGHESNET = 'hughesnet',
    METRONET = 'metronet',
}

@Component({
    selector: 'app-autopay-paperless-payment',
    templateUrl: './autopay-paperless-payment.component.html',
    styleUrl: './autopay-paperless-payment.component.scss',
    standalone: false
})

export class AutopayPaperlessPaymentComponent extends BaseComponent implements OnInit, OnChanges {

  #fb: FormBuilder = inject(FormBuilder)
  autopayPaperlessPaymentForm: FormGroup
  @Input() todaysChargesApplicable: boolean
  @Input() autopayEnrollementValid: boolean
  @Input() ServiceAvailabilityZipCode = ''
  @Input() PaymentZipMustMatchService = false
  @Input() orderFlowType: OrderFlowType
  @Input() customerName = ''
  @ViewChild('autopayCreditCardBilling')
  creditCardBillingComponent: CreditCardBillingComponent

  @ViewChild('autopayAchBilling')
  achBillingComponent: AchBillingComponent
  flowTypeAccordion = true
  autopayTermsExpanded = true
  @Input() autopaySelection = false
  @Input() paymentAllowAch = false
  @Input() autopayEnrollmentTermsUrl = ''
  @Input() paperlessEnrollmentTermsUrl = ''
  @Input() autopayConsentHtml = ''
  @Input() autopayTermsHtml = ''
  @Input() paperlessConsentHtml = ''
  @Input() isOofAutopay = false
  @Input() providerType = ''
  @Input() lockAutopayToggle = false
  @Input() hidePaperless = false
  languageService: LanguageStateService = inject(LanguageStateService)
 readonly OOFProvidersEnum = OOFProvidersEnum
 readonly OrderFlowType = OrderFlowType
 isHidePaperlessForViasatInternet(): boolean {
    return this.hidePaperless && this.providerType?.toLowerCase() === OOFProvidersEnum.VIASAT && this.orderFlowType === OrderFlowType.Internet
  }
 isOofAutopayForViasatInternet(): boolean {
    return this.isOofAutopay && this.providerType?.toLowerCase() === OOFProvidersEnum.VIASAT && this.orderFlowType === OrderFlowType.Internet
  }
  ngOnInit(): void {
    this.autopayPaperlessPaymentForm = this.#fb.group({
      paperlessEnrollment: [{ value: true, disabled: true }, Validators.requiredTrue],
      autopayEnrollment: [this.autopaySelection],
      payWithAch: [false],
      samePaymentMethod: [false],
      paperlessEnrollmentTerms: [{ value: true, disabled: true }, Validators.requiredTrue],
      autopayEnrollmentTerms: [false]
    })

    this.subscriptions.add(this.autopayPaperlessPaymentForm.get('payWithAch')?.valueChanges.subscribe(() => {
      this.autopayPaperlessPaymentForm.get('samePaymentMethod')?.setValue(false)
    }))

    if (this.autopaySelection) {
      this.autopayPaperlessPaymentForm.get('autopayEnrollmentTerms').enable()
      this.autopayPaperlessPaymentForm.get('autopayEnrollmentTerms').addValidators(Validators.requiredTrue)
      this.autopayPaperlessPaymentForm.updateValueAndValidity()
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['autopaySelection'] && this.autopayPaperlessPaymentForm) {
      this.autopayPaperlessPaymentForm.get('autopayEnrollment')?.setValue(this.autopaySelection)
    }
  }

  autopayEnrollmentChange(event: boolean) {
    if (!event) {
      this.autopayPaperlessPaymentForm.get('autopayEnrollmentTerms').removeValidators(Validators.requiredTrue)
      this.autopayPaperlessPaymentForm.get('autopayEnrollmentTerms').setValue(false)
      this.autopayPaperlessPaymentForm.get('autopayEnrollmentTerms').disable()
    } else {
      this.autopayPaperlessPaymentForm.get('autopayEnrollmentTerms').enable()
      this.autopayPaperlessPaymentForm.get('autopayEnrollmentTerms').addValidators(Validators.requiredTrue)
    }
    this.autopayPaperlessPaymentForm.updateValueAndValidity()
  }

  toggleAccordion() {
    this.flowTypeAccordion = !this.flowTypeAccordion
  }

  toggleAutopayTerms() {
    this.autopayTermsExpanded = !this.autopayTermsExpanded
  }

  openAutoPayTerms() {
    window.open(this.autopayEnrollmentTermsUrl, '_blank')
  }

  openPaperlessBillingTerms() {
    window.open(this.paperlessEnrollmentTermsUrl, '_blank')
  }
}
